import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Box, Typography } from '@mui/material';

interface MarkdownContentProps {
  content: string;
}

export const MarkdownContent: React.FC<MarkdownContentProps> = ({ content }) => (
  <Box
    sx={{
      '& img': {
        width: '100%',
        borderRadius: 2,
        boxShadow: '0 12px 24px rgba(15, 23, 42, 0.18)',
      },
      '& ul, & ol': {
        paddingLeft: 3,
        marginTop: 0,
        marginBottom: 2,
      },
      '& li': {
        marginBottom: 0.5,
      },
      '& p:last-of-type': {
        marginBottom: 0,
      },
    }}
  >
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        p: ({ children }) => (
          <Typography
            variant="body1"
            color="inherit"
            sx={{ mb: 1.5, whiteSpace: 'pre-wrap', lineHeight: 1.6, fontSize: { xs: '1rem', sm: '1.05rem' } }}
          >
            {children}
          </Typography>
        ),
        h1: ({ children }) => (
          <Typography variant="h6" color="inherit" sx={{ mt: 2, mb: 1 }}>
            {children}
          </Typography>
        ),
        h2: ({ children }) => (
          <Typography variant="subtitle1" color="inherit" sx={{ mt: 2, mb: 1 }}>
            {children}
          </Typography>
        ),
        h3: ({ children }) => (
          <Typography variant="subtitle2" color="inherit" sx={{ mt: 2, mb: 1 }}>
            {children}
          </Typography>
        ),
        li: ({ children }) => (
          <li>
            <Typography variant="body1" component="span" color="inherit">
              {children}
            </Typography>
          </li>
        ),
        img: ({ src, alt }) => (
          <Box
            component="img"
            src={src}
            alt={alt || 'FRCS figure'}
            loading="lazy"
            sx={{ my: 1.5 }}
          />
        ),
        strong: ({ children }) => (
          <Box component="strong" sx={{ fontWeight: 600 }}>
            {children}
          </Box>
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  </Box>
);
